import React, { createContext, useContext } from 'react';

export interface InitialSnapshot {
  version: string;
  week_key: string;
  workspace_id: string;
  updated_at: string;
  funnel: {
    impressions: number;
    clicks: number;
    conversions: number;
    revenue: number;
  } | null;
  creators: Array<{
    id: string;
    handle: string;
    platform: string;
    metrics: any;
    avatar: string | null;
    aspect: number;
  }>;
  liveAssets: Array<{
    id: string;
    platform: string;
    url: string;
    thumb: string | null;
    aspect: number;
  }>;
}

interface InitialDataContextType {
  initialData: InitialSnapshot | null;
}

const InitialDataContext = createContext<InitialDataContextType | null>(null);

export const InitialDataProvider: React.FC<{
  children: React.ReactNode;
  data: InitialSnapshot | null;
}> = ({ children, data }) => {
  return (
    <InitialDataContext.Provider value={{ initialData: data }}>
      {children}
    </InitialDataContext.Provider>
  );
};

export const useInitialData = (): InitialDataContextType => {
  const context = useContext(InitialDataContext);
  if (!context) {
    throw new Error('useInitialData must be used within InitialDataProvider');
  }
  return context;
};


